const twoLetterWordsBlacklist = ['of']

export const join = (arr: any[] = [], string = ' ⋅ ') =>
  arr
    .filter(x => x || x === 0)
    .map(x => (isNumeric(x) ? n(x) : x))
    .join(string)

export const n = (x: string | number = '') => x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u0020')

export const s = (x: string | number = '', lower?: boolean) => {
  const str = x.toString().trim()
  return lower ? str.toLowerCase() : str
}

export const r = (x: number) => x && Math.round(x)

export const toString = (x?: any): string => (x || x === 0 ? x.toString() : '')

export const isNumeric = (n: string | number | undefined) => !isNaN(parseFloat(`${n}`)) && isFinite(Number(n))

// Form inputs and select options hold numbers as strings; the campaigns service rejects a quoted
// number, and an empty optional has to be null rather than ''.
export const toNumber = (value: any) => (typeof value === 'number' ? value : Number(value))

export const toOptionalNumber = (value: any) => (value === '' || value == null ? null : toNumber(value))

export const isInteger = (value: string) => {
  const x = parseFloat(value)
  return !isNaN(Number(value)) && (x | 0) === x
}

export const round = (v: number, n = 0) => (isNaN(v) ? null : v.toFixed(n))

export const customRound = (v: number, p = 0.5) => (v - Math.floor(v) >= p ? Math.ceil(v) : Math.floor(v))

export const toPercent = (v: number | string, n = 0, string = true, limitTo100 = true) => {
  if (isNaN(Number(v))) return
  const percent = Number(round(Number(v) * 100, n))
  const p = percent > 100 && limitTo100 ? 100 : percent
  return string ? `${p}%` : p
}

export const capitalize = (x: string) => (x ? `${x.charAt(0).toUpperCase()}${x.slice(1).toLowerCase()}` : '')

export const capitalizedWords = (x: string) =>
  x
    .match(/[A-Za-z][a-z]*/g)
    ?.map(capitalize)
    .join(' ')

export const capitalizePhrase = (x: string) => x.trim().split(' ').map(capitalize).join(' ')

export const transformToCompanyName = (x: string) =>
  x
    .split(' ')
    .map(x => (x.length === 2 ? (twoLetterWordsBlacklist.includes(x) ? x : x.toUpperCase()) : capitalize(x)))
    .join(' ')

export const truncate = (x: string, n = 40) => x && `${x.slice(0, n)}${x.length > n ? '...' : ''}`

export const dropProtocol = (x: string) =>
  x
    ? x
        .replace('www.', '')
        .replace(/(https?:)\/\//, '')
        .replace(/\/$/, '')
    : ''

export const dropQuery = (x: string) => (x ? x.split('?')[0] : '')

export const isActiveURL = (to: string) => {
  const path = window.location.pathname
  return path.split('/')[1] === to.split('/')[1] || path.indexOf(to) > -1
}

export const isEmptyObject = (o: Object) => Object.keys(o).length === 0

export const cleanUrl = (x: string) => (x ? dropProtocol(dropQuery(x)) || '/' : '')

export const cleanDomain = (x: string) => (x ? dropProtocol(x).split('/')[0] : '')

export const uuid = () => Math.random().toString(36).substring(10)

export const numberFormatter = (amount: string | number) => {
  const value = typeof amount === 'string' ? parseFloat(amount) : amount
  if (value >= 1000000000) return `${Math.round(value / 1000000000)}B`
  if (value >= 1000000) return `${Math.round(value / 1000000)}M`
  if (value >= 10000) return `${Math.round(value / 1000)}k`
  return value.toString()
}

export const getInitials = (name = '') => {
  if (!name) return ''
  const parts = name.split(/\s|-/)

  if (parts.length === 1) return parts[0].substr(0, 2).toUpperCase()

  const words = parts.filter(w => /^[a-zA-Z0-9]/.test(w))
  if (!words.length) {
    return ''
  }
  if (words.length === 1) {
    return words[0].substr(0, 2).toUpperCase()
  }
  if (words.length > 1) {
    return `${words[0][0].toUpperCase()}${words[1][0].toUpperCase()}`
  }
}
